/* ------------ Global Vendors Components -------------- */

import Multiselect from "vue-multiselect"

function setupVendorComponents(Vue){
    Vue.component('Multiselect', Multiselect)
}

export {
    setupVendorComponents
}